<template>
    <div class="group-analysis-setting-view">
        <div v-if="addShow" class="sub-header">
            <div class="front-block">
                <div class="handle"></div>
                <div class="title">群組名稱</div>
            </div>

            <div class="description">
                <div v-if="isIncomeStatement" class="label">
                    綜合損益表-自結報表
                </div>
                <div v-else class="combo">
                    <div class="label">財務分析初始金額</div>
                    <div class="label">財務分析表</div>
                </div>
            </div>

            <div class="back-block">
                <div class="edit-label">編輯</div>
            </div>
        </div>
        <DraggableWrapper
            :value="data"
            :onDragEnd="onDragEnd"
            :onAdd="onAdd"
            :onChange="onChange"
            :onEdit="onEdit"
            :addShow="addShow"
            :isShowMem="false"
            :isSysAllow="!isIncomeStatement"
            v-slot="slotProps"
            @input="val => $emit('input', val)"
        >
            <div class="select">
                <el-select
                    v-if="isIncomeStatement"
                    v-model="slotProps.form.incomeStatementType"
                    :disabled="!isD18Payed || slotProps.disabled || isQR()"
                    placeholder="綜合損益表"
                    style="width: 195px"
                    @change="onChangeDetail(slotProps)"
                >
                    <el-option v-for="item in incomeStatementList" :label="`${item.id}. ${item.value}`" :value="item.id" :key="item.id" :disabled="!isIncomeOptionUsable(item.id)"></el-option>
                </el-select>

                <div v-else>
                    <MoneyInput
                        v-model="slotProps.form.financeStatementInitialPrice"
                        :disabled="!isD19Payed || slotProps.disabled"
                        :update-on-key-up="false"
                        allow-negative
                        placeholder="財務分析初始金額"
                        style="width: 195px; margin-right: 20px"
                        @change="onChangeDetail(slotProps)"
                    />
                    <el-select
                        v-model="slotProps.form.financeStatementType"
                        :disabled="!isD19Payed || slotProps.disabled || isQR()"
                        placeholder="財務分析表"
                        style="width: 195px"
                        @change="onChangeDetail(slotProps)"
                    >
                        <el-option v-for="item in financeStatementList" :label="`${item.id}. ${item.value}`" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                </div>
            </div>
        </DraggableWrapper>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { financeStatementList, accountingSettingGroup } from '@/assets/commonData/options';
import DraggableWrapper from './DraggableWrapper.vue';

export default {
    props: {
        value: Array,

        onDragEnd: { type: Function, default: () => {} },
        onChange: { type: Function, default: () => {} },
        onEdit: { type: Function, default: () => {} },
        onAdd: { type: Function, default: () => {} },

        activeCategory: [Number, String],
    },
    components: { DraggableWrapper },
    data() {
        return {
            isDragging: false,

            incomeStatementList: [],
            incomeStatementType: '',

            financeStatementList,
            financeStatementType: '',
            financeStatementInitialPrice: 0,
            data: [],

            incomeStateRelation: [
                {
                    category: 'invoiceSettings', // 營業收入
                    canUseTypes: [4], // 4.營業收入
                },
                {
                    category: 'payoutSettings', // 營業支出
                    canUseTypes: [5, 6], // 5.營業成本 | 6.營業費用
                },
                {
                    category: 'cInSettings', // 營業其他收入
                    canUseTypes: [7], // 7.營業外收入
                },
                {
                    category: 'cOutSettings', // 營業其他支出
                    canUseTypes: [6, 8], // 8.營業外支出
                },
            ],
        };
    },
    computed: {
        ...mapGetters({ isAhooAgent: 'account/isAhooAgent' }),
        addShow() {
            this.updateForm();
            return !!this.activeCategory;
        },
        isIncomeStatement() {
            return this.activeCategory === 'invoiceSettings' || this.activeCategory === 'payoutSettings' || this.activeCategory === 'cInSettings' || this.activeCategory === 'cOutSettings';
        },
        isD18Payed() {
            if (this.isAhooAgent) return true;
            return this.isPayed('D18');
        },
        isD19Payed() {
            if (this.isAhooAgent) return true;
            return this.isPayed('D19');
        },
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.incomeStatementList = [...accountingSettingGroup.filter((o) => o.id > 3 && o.id < 9)];
        },
        isIncomeOptionUsable(incomeStateId) {
            const cate = this.incomeStateRelation.find((x) => x.category === this.activeCategory);
            return cate.canUseTypes.includes(incomeStateId);
        },
        updateForm() {
            if (this.isIncomeStatement) {
                this.data = _.map(this.value, (o) => ({
                    ...o,
                    form: {
                        incomeStatementType: o.grP_NAM || undefined,
                    },
                }));
            } else {
                this.data = _.map(this.value, (o) => ({
                    ...o,
                    form: {
                        financeStatementType: o.grP_NAM || undefined,
                        financeStatementInitialPrice: o.grP_AMT,
                    },
                }));
            }
        },
        onEnd(val) {
            this.onDragEnd(val);
            this.isDragging = false;
        },

        async onChangeDetail({ sno, form }) {
            const groupName = this.isIncomeStatement ? form.incomeStatementType : form.financeStatementType;
            const groupAmt = this.isIncomeStatement ? undefined : form.financeStatementInitialPrice;
            const found = _.find(this.value, ['sno', sno]);

            await this.$api({
                url: '/IncomeStatementSettingPage/UpdateGroup',
                method: 'POST',
                data: {
                    sno,
                    iteM_NAM: found.iteM_NAM,
                    isshare: found.isshare,
                    grP_NAM: groupName,
                    grP_MEM: found.grP_MEM,
                    grP_AMT: groupAmt,
                },
            });
            this.$emit('update');
        },
    },
};
</script>

<style lang="scss">
.group-analysis-setting-view {
    .front-block {
        display: flex;
        align-items: center;
        flex: 1;
        margin: 0 5px 0 0;
    }
    .back-block {
        flex: 1;
        display: flex;
        justify-content: flex-end;
    }
    .edit-label {
        width: 30px;
        text-align: center;
    }

    .item.draggable {
        padding-top: 2px;
        padding-bottom: 3px;
    }
}
</style>
